import maintenanceImage from '@/assets/images/maintenance.gif';

export const UnderMaintenance = () => {
    return (
        <div className="mx-auto flex h-[calc(100vh_-_var(--header-height)_*_2)] max-w-full flex-col items-center justify-center pt-4">
            <img
                src={maintenanceImage}
                className="h-4/5 w-auto object-contain"
                alt={'Under Maintenance'}
            />
            <p className="font-primary text-2xl font-bold text-destructive">
                This Feature is Under Maintenance
            </p>
            <p className="font-primary text-lg font-bold text-destructive/50">
                It will be available soon!
            </p>
        </div>
    );
};

UnderMaintenance.displayName = 'UnderMaintenance';
